var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quizset-button-delete",on:{"click":_vm.remove}},[_vm._v("\n  クイズセットの削除\n")])}
var staticRenderFns = []

export { render, staticRenderFns }